// extracted by mini-css-extract-plugin
module.exports = {"btnWrapper":"UploadAgreementContainer_btnWrapper__nypw6"};